import { render, staticRenderFns } from "./RecentlyAddedSidebarActions.vue?vue&type=template&id=06fdc014&scoped=true&"
import script from "./RecentlyAddedSidebarActions.vue?vue&type=script&lang=ts&"
export * from "./RecentlyAddedSidebarActions.vue?vue&type=script&lang=ts&"
import style0 from "./RecentlyAddedSidebarActions.vue?vue&type=style&index=0&id=06fdc014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fdc014",
  null
  
)

export default component.exports